const OPT_OUT_KEY = 'perch_analytics_opt_out';

export function isOptedOut(): boolean {
  return localStorage.getItem(OPT_OUT_KEY) === '1';
}

export function optOut(): void {
  localStorage.setItem(OPT_OUT_KEY, '1');
}

export function optIn(): void {
  localStorage.removeItem(OPT_OUT_KEY);
}
